/* ==========================================================================
   Buena Vita — goal finder

   Two questions, then matches drawn from the section's embedded product JSON.
   Matching is a plain tag intersection — there is no scoring model pretending
   to be cleverer than it is, because with a nine-product catalogue a weighted
   score would be theatre.

   Results write into `bv:routine`, the SAME localStorage key the routine
   builder reads, so finishing the quiz fills the builder further down the page
   instead of dead-ending in a list.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__bvQuizInit) return;
  window.__bvQuizInit = true;

  var KEY = 'bv:routine';

  function $all(sel, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(sel));
  }

  function money(cents) {
    if (window.BVFX && window.BVFX.money) return window.BVFX.money(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function initSection(section) {
    if (section.dataset.bvQuizBound === '1') return;
    section.dataset.bvQuizBound = '1';

    var dataNode = section.querySelector('[data-bv-quiz-data]');
    var products = [];
    try { products = JSON.parse(dataNode.textContent) || []; } catch (err) { products = []; }
    if (!products.length) return;

    var steps = $all('[data-bv-step]', section);
    var pips = $all('[data-bv-pip]', section);
    var resList = section.querySelector('[data-bv-res]');
    var resHead = section.querySelector('[data-bv-res-head]');
    var addBtn = section.querySelector('[data-bv-res-add]');
    var addLabel = addBtn ? addBtn.textContent.trim() : 'Add these to my routine';

    var state = { goal: null, depth: 1, matches: [] };

    function show(i) {
      steps.forEach(function (s) {
        s.hidden = parseInt(s.getAttribute('data-bv-step'), 10) !== i;
      });

      pips.forEach(function (p, n) {
        p.classList.toggle('is-done', n < i);
        p.classList.toggle('is-current', n === i);
      });

      /* Move focus to the new step's heading so a screen reader and a keyboard
         user both land in the right place, rather than being left on a button
         that just disappeared. */
      var head = steps[i] && steps[i].querySelector('.bv-quiz__q');
      if (head) {
        head.setAttribute('tabindex', '-1');
        head.focus({ preventScroll: true });
      }
    }

    function compute() {
      var hits = products.filter(function (p) {
        return (p.tags || '').split(/\s+/).indexOf(state.goal) !== -1;
      });

      /* Cheapest first when someone asked for one thing — the single best match
         for a newcomer is the lowest-commitment one, not the highest-margin
         one. Left in the catalogue's own order otherwise. */
      if (state.depth === 1) hits.sort(function (a, b) { return a.price - b.price; });

      state.matches = hits.slice(0, state.depth);
    }

    function render() {
      compute();

      if (resHead) {
        resHead.textContent = state.matches.length === 1
          ? 'Start with this one'
          : "Here's what matches";
      }

      resList.innerHTML = state.matches.map(function (p, i) {
        return (
          '<li class="bv-quiz__hit" style="animation-delay:' + i * 70 + 'ms">' +
          (p.image ? '<img class="bv-quiz__hit-img" src="' + esc(p.image) + '" alt="" width="62" height="62">' : '') +
          '<div class="bv-quiz__hit-txt">' +
          '<a class="bv-quiz__hit-t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          (p.why ? '<p class="bv-quiz__hit-d">' + esc(p.why) + '</p>' : '') +
          '<p class="bv-quiz__hit-p">' + esc(money(p.price)) + '</p>' +
          '</div></li>'
        );
      }).join('');

      if (!state.matches.length) {
        resList.innerHTML =
          '<li class="bv-quiz__hit"><div class="bv-quiz__hit-txt">' +
          '<p class="bv-quiz__hit-d">Nothing in the range covers that yet. ' +
          'The full catalogue is worth a look anyway.</p></div></li>';
      }

      if (addBtn) {
        addBtn.hidden = !state.matches.length;
        addBtn.disabled = false;
        addBtn.textContent = addLabel;
      }

      show(2);
    }

    /* ---------- controls ---------- */

    $all('[data-bv-goal]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.goal = btn.getAttribute('data-bv-goal');
        $all('[data-bv-goal]', section).forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        show(1);
      });
    });

    $all('[data-bv-depth]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.depth = parseInt(btn.getAttribute('data-bv-depth'), 10) || 1;
        $all('[data-bv-depth]', section).forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        render();
      });
    });

    var back = section.querySelector('[data-bv-back]');
    if (back) back.addEventListener('click', function () { show(0); });

    var restart = section.querySelector('[data-bv-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        state = { goal: null, depth: 1, matches: [] };
        $all('[data-bv-goal], [data-bv-depth]', section).forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        show(0);
      });
    }

    /* ---------- hand off to the routine builder ---------- */

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!state.matches.length) return;

        var current = [];
        try { current = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (err) { current = []; }
        if (!Array.isArray(current)) current = [];

        state.matches.forEach(function (p) {
          if (current.indexOf(p.handle) === -1) current.push(p.handle);
        });

        try { localStorage.setItem(KEY, JSON.stringify(current)); } catch (err) { /* private mode */ }

        addBtn.textContent = 'Added to your routine';
        addBtn.disabled = true;

        /* The builder is a separate section that already read localStorage on
           load, so it has to be told. Rebinding is not possible from here, so
           the page is asked to re-run it: bv-stack listens for this event. */
        document.dispatchEvent(new CustomEvent('bv:routine:changed', { detail: { handles: current } }));

        var stack = document.querySelector('[data-bv-stack]');
        if (stack) {
          stack.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      });
    }

    show(0);
  }

  function boot(scope) {
    $all('[data-bv-quiz]', scope || document).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
